<template>
  <Card>
    <span slot="title">医生荣誉称号管理</span>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getTitlesData)" class="fr">刷新</el-button>
    <div slot="content" class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="称号名称">
            <el-input v-model="searchForm.titleName" placeholder="请输入称号名称"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getTitlesData, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getTitlesData, { titleName: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
      <el-button icon="el-icon-plus" type="primary" @click="addTitle">新增荣誉称号</el-button>
      </div>
      <!-- 称号列表 -->
      <el-table v-loading="loading" :max-height="tableHeight"
        :data="titleList" ref="multipleTable" border>
        <el-table-column prop="titleName" label="称号名称"/>
        <el-table-column prop="sortNum" label="显示顺序"/>
        <el-table-column prop="createTime" label="创建时间" min-width="150"/>
        <el-table-column prop="updateTime" label="更新时间" min-width="150"/>
        <el-table-column prop="updateBy" label="操作人"/>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="ediTtitle(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="" :title="dialogTitle" :visible.sync="dialogVisible"
        width="340px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="称号名称" prop="titleName">
            <el-input v-model="editForm.titleName" placeholder="请输入称号名称"/>
          </el-form-item>
          <el-form-item label="显示顺序" prop="sortNum">
            <el-input-number :min="1"  v-model="editForm.sortNum" placeholder="请输入称号名称"> </el-input-number>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增称号'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑称号'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getTitlesData)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </Card>
</template>

<script lang="js">
import { titleList, titleEdit, titleAdd } from "@/api/title"; // 称号请求
import Card from '@/components/Card.vue';
export default {
  components: { Card },
  data() {
    return {
      loading: true, // 加载中
      searchForm: { titleName: null, titleCode: null }, // 查询表单
      titleList: [], // 称号列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      editFormRules: {
        titleName: [{required: true, message: "称号名称不能为空！", trigger: "blur"}],
        sortNum:[{required: true, message: "显示顺序不能为空！", trigger: "blur"}]
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getTitlesData(); // 页面初始化获取称号列表
  },
  methods: {
    // 请求所有称号列表
    async getTitlesData() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await titleList(params);
      if (code == 200) {
        this.total = total;
        this.titleList = rows;
      }
      this.loading = false;
    },
    // 新增称号
    addTitle() {
      this.dialogVisible = true;
      this.dialogTitle = "新增称号";
      this.editForm = { titleName: null,sortNum:1 };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          titleAdd(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增称号成功！");
            this.dialogVisible = false;
            this.$refresh(this.getTitlesData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 编辑称号信息
    async ediTtitle(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑称号";
      this.dialogVisible = true;
    },
    // 保存称号修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          titleEdit(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("修改称号成功！");
            this.dialogVisible = false;
            this.$refresh(this.getTitlesData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    }
  },
};
</script>